import React, { useState, useEffect, useCallback } from 'react'
import { X, ChevronLeft, ChevronRight } from 'lucide-react'

export default function Lightbox({ images, startIdx, caption, captions, onClose }) {
  const [idx, setIdx] = useState(startIdx ?? 0)
  const prev = useCallback(() => setIdx(i => (i - 1 + images.length) % images.length), [images.length])
  const next = useCallback(() => setIdx(i => (i + 1) % images.length), [images.length])

  useEffect(() => {
    const onKey = e => {
      if (e.key === 'ArrowLeft')  prev()
      if (e.key === 'ArrowRight') next()
      if (e.key === 'Escape')     onClose()
    }
    window.addEventListener('keydown', onKey)
    document.body.style.overflow = 'hidden'
    return () => { window.removeEventListener('keydown', onKey); document.body.style.overflow = '' }
  }, [prev, next, onClose])

  const currentCaption = captions ? captions[idx] : caption
  const label = currentCaption ? `${currentCaption} — ${idx + 1} / ${images.length}` : `${idx + 1} / ${images.length}`

  return (
    <div className="sc-lightbox" onClick={onClose}>
      <button className="sc-lightbox__close" onClick={onClose}><X size={20} /></button>
      <button className="sc-lightbox__nav sc-lightbox__nav--prev" onClick={e => { e.stopPropagation(); prev() }}>
        <ChevronLeft size={28} />
      </button>
      <div className="sc-lightbox__stage" onClick={e => e.stopPropagation()}>
        <img src={images[idx]} alt={label} className="sc-lightbox__img" />
        <div className="sc-lightbox__counter">{label}</div>
      </div>
      <button className="sc-lightbox__nav sc-lightbox__nav--next" onClick={e => { e.stopPropagation(); next() }}>
        <ChevronRight size={28} />
      </button>
    </div>
  )
}
